// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9562 ? "3975359d" : chunkId) + "." + {"3865":"bbe8e8197c88e8dc","9088":"2341072fde7b85b3","9562":"fa4ad9f44d4c95f1"}[chunkId] + ".js";
};